"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceWithoutCashback = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _localization = require("@lt/localization");

var _CashBackIcon = require("../../../CashBack/components/CashBackIcon");

var _currency = require("../../../../utils/currency");

/**
 * Выводит цену отеля без учета баллов кешбэка
 */
var PriceWithoutCashback = function PriceWithoutCashback(_ref) {
  var count = _ref.count,
      currencyCode = _ref.currencyCode;

  var _useTranslation = (0, _localization.useTranslation)(),
      t = _useTranslation.t;

  if (!count) return null;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, (0, _currency.formatCurrency)(count, currencyCode), "\xA0\xA0", t('hotelcard.card.offer.withoutCashback'), /*#__PURE__*/_react["default"].createElement(StyledCashbackIcon, {
    size: "s"
  }));
};

exports.PriceWithoutCashback = PriceWithoutCashback;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "PriceWithoutCashback__Wrapper",
  componentId: "sc-1ce37hk-0"
})(["display:inline-block;flex-shrink:0;padding:1px 5px 1px 3px;font-size:14px;line-height:16px;color:", ";border:1px solid ", ";border-radius:2px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyLight;
});

var StyledCashbackIcon = (0, _styledComponents["default"])(_CashBackIcon.CashBackIcon).withConfig({
  displayName: "PriceWithoutCashback__StyledCashbackIcon",
  componentId: "sc-1ce37hk-1"
})(["position:relative;top:1px;margin-left:3px;"]);